import BottomNavigation from "components/app-navigation/components/phone-navigation/components/bottom-navigation/BottomNavigation";
// import ConnectStripeBanner from "components/connect-stripe-banner/ConnectStripeBanner";
import ErrorTag from "components/error-tag";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useTimeOnPageContext } from "contexts/time-on-page";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeSidesheet,
  hideMobileSidebar,
  selectIsMobileSidebarVisible,
} from "store/calendarSidebarSlice";
import { PRO_CALENDAR_ANALYTICS_PAGE_NAME } from "utils/amplitude";
import getClasses from "utils/getClasses";
import TutorialCompleteModal from "../tutorial-complete-modal";
import styles from "./OneOnOneSessionsPageLayout.module.scss";
import CalendarHeaderMobile from "./components/calendar-header-mobile/CalendarHeaderMobile";
import CalendarHeader from "./components/calendar-header/CalendarHeader";
import CalendarSidebar from "./components/calendar-sidebar/CalendarSidebar";
import SidesheetContainer from "./components/calendar-sidebar/sidesheet-container/SidesheetContainer";
import CalendarView from "./components/calendar-view/CalendarView";
import SessionTypesEditor from "./components/calendar-view/components/session-types-editor/SessionTypesEditor";
import { useCalendarNotifications } from "./contexts/calendar-notifications-context";

const OneOnOneSessionsPageLayout = () => {
  const dispatch = useDispatch();
  const { isPhonePortrait } = usePhonePortraitContext();

  const isMobileSiebarVisible = useSelector(selectIsMobileSidebarVisible);

  const { setPage } = useTimeOnPageContext();
  useEffect(() => {
    setPage(PRO_CALENDAR_ANALYTICS_PAGE_NAME);
  }, [setPage]);

  const { notifications, removeNotification } = useCalendarNotifications();

  useEffect(
    () => () => {
      dispatch(closeSidesheet());
    },
    [dispatch],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <TutorialCompleteModal />
      <SessionTypesEditor
        analyticsPageName={PRO_CALENDAR_ANALYTICS_PAGE_NAME}
      />

      <div className={styles["container"]}>
        <div
          className={getClasses(
            styles["calendar-content-column"],
            isPhonePortrait && styles["calendar-content-column--phone"],
          )}
        >
          {/* <ConnectStripeBanner
            amplitudePageName={PRO_CALENDAR_ANALYTICS_PAGE_NAME}
          /> */}
          <div className={styles["notifications-wrapper"]}>
            <div className={styles["notifications"]}>
              {notifications.map((notification) => (
                <ErrorTag
                  className={styles["error-tag"]}
                  key={notification.id}
                  show={true}
                  onHide={() => removeNotification(notification)}
                  duration={5000}
                  errorMsg={notification.message}
                />
              ))}
            </div>
            {isPhonePortrait ? <CalendarHeaderMobile /> : <CalendarHeader />}
            <CalendarView
              amplitudePageName={PRO_CALENDAR_ANALYTICS_PAGE_NAME}
            />
            {/* {VIEW_STATES.CALENDAR.id === selectedViewStateId && (
              <CalendarView
                hasBanner={hasBanner}
                amplitudePageName={ANALYTICS_PAGE_NAME}
              />
            )}
            {VIEW_STATES.LIST.id === selectedViewStateId && (
              <PatientChartSessionsListView hasBanner={hasBanner} />
            )} */}
          </div>
          {isPhonePortrait && <BottomNavigation includeInLayout />}
        </div>
        {!isPhonePortrait && <CalendarSidebar />}
      </div>

      {isPhonePortrait && (
        <>
          <div
            className={getClasses(
              styles["mobile-sidebar-wrapper"],
              !isMobileSiebarVisible &&
                styles["mobile-sidebar-wrapper--hidden"],
            )}
            onClick={(event) => {
              if (event.target === event.currentTarget) {
                dispatch(hideMobileSidebar());
              }
            }}
          >
            <CalendarSidebar />
          </div>
          <SidesheetContainer />
        </>
      )}
    </>
  );
};

export default OneOnOneSessionsPageLayout;
